import { CellProps } from 'react-table'
import { CoordenadorActionsCell } from './CoordenadorActionsCell'
import { ColaboradorList } from '../../core/_models'
import { PlainHeader, StackedCell, TableColumn } from '../../../../../../components'
import { formatDateTime } from '../../../../../../../_metronic/helpers'
import { TFunction } from '_metronic/i18n/Metronici18n'

/** LocalDateTime do backend → "dd/mm/aaaa hh:mm"; ausente vira o traço do StackedCell. */
const dataHora = (date?: string) => (date ? formatDateTime(date) : undefined)

/** "12345/SP": número do conselho com a UF, como aparece no carimbo. */
const conselho = (c: ColaboradorList) => (c.crm ? [c.crm, c.uf].filter(Boolean).join('/') : '')

// Lista vem inteira do empregador (sem paginação/ordenação no backend): cabeçalhos sem sort.
export const coordenadorColumns = (t: TFunction): ReadonlyArray<TableColumn<ColaboradorList>> => [
  {
    Header: () => <PlainHeader>Coordenador</PlainHeader>,
    id: 'nome',
    Cell: ({ row }: CellProps<ColaboradorList>) => <StackedCell primary={row.original.nome} />,
  },
  {
    Header: () => <PlainHeader>Conselho de classe / RQE</PlainHeader>,
    id: 'crm',
    cellWidth: '220px',
    Cell: ({ row }: CellProps<ColaboradorList>) => (
      <StackedCell
        tabular
        primary={conselho(row.original) || undefined}
        secondary={row.original.rqe}
      />
    ),
  },
  // Última edição em destaque; criação como linha de apoio.
  {
    Header: () => (
      <PlainHeader>
        {t('cols.data.edicao')} / {t('cols.data.criacao')}
      </PlainHeader>
    ),
    id: 'dataAlteracao',
    cellWidth: '188px',
    hideOnMobile: true,
    Cell: ({ row }: CellProps<ColaboradorList>) => (
      <StackedCell
        tabular
        primary={dataHora(row.original.dataAlteracao)}
        secondary={dataHora(row.original.dataInclusao)}
      />
    ),
  },
  {
    Header: () => <PlainHeader>{t('cols.actions')}</PlainHeader>,
    id: 'actions',
    cellWidth: '132px',
    align: 'end',
    Cell: ({ row }: CellProps<ColaboradorList>) => (
      <CoordenadorActionsCell coordenador={row.original} />
    ),
  },
]
